import { module } from "angular";
import { Config } from "./EnvBasedConfig";

module("irUtils").constant("irConfig", Config);
